export const PASSWORD_SPECIALS = '! @ # $ % ^ & * ( ) _ + - = { } . , ?';

export const PASSWORD_RULE_MESSAGE =
  '영문, 숫자, 허용 특수문자를 조합해 최대 20자로 입력해주세요.';

export const PASSWORD_PATTERN =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}.,?])[A-Za-z\d!@#$%^&*()_+\-={}.,?]{1,20}$/;
